import * as styles from "./CategorySelect.css";

import { useAtomValue } from "jotai";

import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";
import {
  Menu,
  MenuContent,
  MenuRadioGroup,
  MenuRadioItem,
  MenuTrigger,
} from "@frontend/components/atoms/Menu";
import { useLingui } from "@lingui/react";

import { useAddressBookActions } from "../../hooks/useAddressBookActions";
import { CategoryFilterLabel } from "../../i18n";
import { categoriesAtom, selectedCategoryAtom } from "../../stores";

export function CategorySelect() {
  const { _ } = useLingui();

  const { selectCategory } = useAddressBookActions();

  const categories = useAtomValue(categoriesAtom);
  const selectedCategory = useAtomValue(selectedCategoryAtom);

  const handleValueChange = (key: unknown) => {
    const category = categories.find((c) => c.key === key);

    if (category) {
      void selectCategory(category);
    }
  };

  const isFiltered =
    selectedCategory !== null && selectedCategory.type !== "all";

  return (
    <Menu arrow align="end">
      <MenuTrigger
        render={(triggerProps) => (
          <Button
            {...triggerProps}
            variant="ghost"
            className={styles.trigger}
            aria-label={_(CategoryFilterLabel)}
            title={selectedCategory?.name}
          >
            <Icon
              name="Users"
              size="sm"
              className={styles.icon({ active: isFiltered })}
            />
          </Button>
        )}
      />

      <MenuContent style={{ minWidth: "14rem" }}>
        <MenuRadioGroup
          value={selectedCategory?.key ?? null}
          onValueChange={handleValueChange}
        >
          {categories.map((category) => (
            <MenuRadioItem key={category.key} value={category.key} closeOnClick>
              <span className={styles.item}>
                <span className={styles.name}>{category.name}</span>

                <span
                  className={styles.count({ badge: category.type === "new" })}
                >
                  {category.contactCount}
                </span>
              </span>
            </MenuRadioItem>
          ))}
        </MenuRadioGroup>
      </MenuContent>
    </Menu>
  );
}
